import type { GetEnrollmentsParams, GetEnrollmentsResponse } from '@repo/types';
import { useQuery } from '@tanstack/react-query';
import { getEnrollments } from '../api/enrollmentApi';

/**
 * @param params - 조회 파라미터 (페이지, 정렬, 필터 등)
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useEnrollments = (params: GetEnrollmentsParams) => {
  return useQuery<GetEnrollmentsResponse>({
    queryKey: ['enrollments', params],
    queryFn: () => getEnrollments(params),

    staleTime: 5 * 60 * 1000,

    retry: 1,

    refetchOnWindowFocus: false,
  });
};
